// extracted by mini-css-extract-plugin
export default {"Events":"Events_Events__ChJ2x"};